import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteMessagesBulk, DeleteMessagesBulkPayload } from "@/api/chats";
import { ChatsQueryKeys } from "@/tanstackQuery/queries/chats";

export const useDeleteMessages = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: DeleteMessagesBulkPayload) =>
      deleteMessagesBulk(payload),
    onSuccess: (_data, { chatId }) => {
      queryClient.invalidateQueries({
        queryKey: [ChatsQueryKeys.ChatMessages, chatId],
      });
      queryClient.invalidateQueries({
        queryKey: [ChatsQueryKeys.ChatMessagesPaginated, chatId],
      });
      queryClient.invalidateQueries({ queryKey: [ChatsQueryKeys.Chats] });
      queryClient.invalidateQueries({
        queryKey: [ChatsQueryKeys.ChatsPaginated],
      });
    },
  });
};
